<template>
  <div
    :class="classes"
    role="status"
    aria-busy="true"
  />
  
</template>

<script>
export default {
  name: 'OSkeleton',
  props: {
    shape: {
      type: String,
      default: 'rect',
      validator: v => ['rect', 'rectangle', 'circle'].includes(v),
    },
    animated: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classes () {
      return [
        'inline-block',
        'overflow-hidden',
        'bg-gray-200',
        'dark:bg-gray-700',
        this.animated ? 'animate-pulse' : '',
        this.shape === 'circle' ? 'rounded-full' : 'rounded',
      ]
    },
  },
}
</script>



